/** Scene YAML frontmatter — mirrors `zw_config.rs` strip/render_frontmatter. */

export function stripSceneFrontmatter(raw: string): {
  synopsis: string;
  body: string;
} {
  if (raw.startsWith("---\n") === false) {
    return { synopsis: "", body: raw };
  }
  const rest = raw.slice(4);
  const end = rest.indexOf("\n---\n");
  if (end < 0) {
    return { synopsis: "", body: raw };
  }
  const yamlBlock = rest.slice(0, end);
  const body = rest.slice(end + 5);
  let synopsis = "";
  for (const line of yamlBlock.split("\n")) {
    const match = line.match(/^synopsis:\s*(.*)$/);
    if (match !== null) {
      synopsis = match[1]?.trim() ?? "";
      if (
        (synopsis.startsWith('"') && synopsis.endsWith('"')) ||
        (synopsis.startsWith("'") && synopsis.endsWith("'"))
      ) {
        synopsis = synopsis.slice(1, -1);
      }
      break;
    }
  }
  return { synopsis, body };
}

/** Peel every leading `---` block off corrupted content before editing/saving. */
export function stripSceneFrontmatterLayers(raw: string): {
  synopsis: string;
  body: string;
} {
  let synopsis = "";
  let body = raw;
  while (body.startsWith("---\n")) {
    const parsed = stripSceneFrontmatter(body);
    if (parsed.body === body) break;
    if (synopsis === "" && parsed.synopsis.trim() !== "") {
      synopsis = parsed.synopsis;
    }
    body = parsed.body;
  }
  return { synopsis, body };
}

export function renderSceneFrontmatter(synopsis: string, body: string): string {
  if (synopsis.trim() === "") return body;
  const yaml = `synopsis: ${JSON.stringify(synopsis)}\n`;
  return `---\n${yaml}---\n${body}`;
}
